export default __webpack_public_path__ + "static/media/LeRoseVilla.7738468f.jpg";